// extracted by mini-css-extract-plugin
export default {"map":"MainMap_map__yNvNm"};